import React, { useEffect } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";

export default function Statistics() {
  useEffect(() => {}, []);

  const Content = () => (
    <section className="home-section">
      <div className="text">Statistiken</div>
      <section className="why" id="statistics">
        <div className="container">
          <h2 style={{ marginBottom: "40px" }}>Statistiken</h2>
          <div className="flex-row write-up">
            <div className="col">
              <i className="fas fa-pencil-alt">
                <FontAwesomeIcon
                  icon={icon({ name: "pencil-alt", style: "solid" })}
                />
              </i>
              <h3>Einheiten</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
            <div className="col">
              <i className="fas fa-signal">
                <FontAwesomeIcon
                  icon={icon({ name: "signal", style: "solid" })}
                />
              </i>
              <h3>Neue Nutzer</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
            <div className="col">
              <i className="fas fa-search">
                <FontAwesomeIcon
                  icon={icon({ name: "search", style: "solid" })}
                />
              </i>
              <h3>Suchen</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
          </div>
          <div className="flex-row analytics">
            <div className="col">
              <span className="number">274</span>
              <span className="title">Aktive Nutzer</span>
            </div>
            <div className="col">
              <span className="number">3</span>
              <span className="title">Trainingspläne</span>
            </div>
          </div>
        </div>
      </section>
    </section>
  );

  const selPage = "statistics";

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>
      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
